import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { AcLedgerGet, AcLedgerService, GetAcledgerParams } from '@app/services/ac-ledger.service';
import { catchError, EMPTY, from, ReplaySubject, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-ac-ledger',
    templateUrl: './ac-ledger.component.html',
    styleUrls: ['./ac-ledger.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class AcLedgerComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public params?: GetAcledgerParams;

    public params$ = new ReplaySubject<GetAcledgerParams>(1);

    private destroy$ = new Subject<void>();

    public get?: AcLedgerGet;

    public acledgerGrid?: GridOptions;

    public acsuppTransGrid?: GridOptions;

    public accustTransGrid?: GridOptions;

    constructor(
        private acledger: AcLedgerService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.params$
            .pipe(
                takeUntil(this.destroy$),
                switchMap((params) => from(this.acledger.getAcledger(params)).pipe(catchError((err) => EMPTY))),
            )
            .subscribe({
                next: (get) => {
                    this.get = get;

                    this.readAcledgerTransGrid();
                    this.readAcsuppTransGrid();
                    this.readAccustTransGrid();

                    if (!!this.navigator && ['dialog', 'popup'].includes(this.navigator?.host)) {
                        this.navigator.setHeading?.(this.get.page_heading ?? '');
                    }
                },
            });
    }

    private readAcledgerTransGrid() {
        if (!this.get) return;

        if (!this.acledgerGrid) {
            this.acledgerGrid = new Grid().setRememberId(this.get.view_id).setLoadDataFunction({ method: 2788, parameters: () => this.get });
        } else {
            this.acledgerGrid.gridfunc?.read();
        }
    }

    private readAcsuppTransGrid() {
        if (!this.get) return;

        if (!this.acsuppTransGrid) {
            this.acsuppTransGrid = new Grid().setRememberId('w_acledger_acsupptrans_grid').setLoadDataFunction({ method: 2789, parameters: () => this.get });
        } else {
            this.acsuppTransGrid.gridfunc?.read();
        }
    }

    private readAccustTransGrid() {
        if (!this.get) return;

        if (!this.accustTransGrid) {
            this.accustTransGrid = new Grid().setRememberId('w_acledger_accustrans_grid').setLoadDataFunction({ method: 2790, parameters: () => this.get });
        } else {
            this.accustTransGrid.gridfunc?.read();
        }
    }

    private async init(params: GetAcledgerParams) {
        this.params = params;
        this.params$.next(this.params);
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.init(this.navigator.params as any);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']?.currentValue) {
            this.init(changes['params'].currentValue);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.params$.complete();
    }
}
